import React from 'react'
import Table from './table'
import hoc from '@hoc'
import PropTypes from 'prop-types'
import { API } from '@const'
import * as utils from '@utils'

const COMPONENT_GROUP = 'member_search';

class PaymentFlowRecordTable extends React.Component {
    constructor(props) {
        super(props)
        this.t = (key, options) => {
            return utils.t(key, 'PaymentFlowRecordTable', options)
        }
    }

    options = {
        export: false
    }

    componentDidMount() {
        this.props.onRef(this)
        if (utils.checkValid(COMPONENT_GROUP + '.export')) {
            this.options.export = true
        }
    }

    componentWillUnmount() {
        this.props.onRef(undefined)
    }

    columns = [
        {
            field: 'created_at',
            type: 'datetime',
        },
        {
            field: 'payment_type',
            translate: {
                dataKey: 'payment_type',
                tranKey: 'PaymentFlowType',
            },
        },
        {
            field: 'money',
            type: 'currency',
        },
        {
            field: 'record_id',
        },
        {
            field: 'remark',
        },
    ]

    SetData(data) {
        this.table.SetData(data, this.props.currency)
    }

    queryData = (queryParams) => {
        this.table.SetLoading(true)

        utils.apiRequest(
            'get',
            API.PAYMENT_FLOW_RECORD_LIST,
            queryParams,
            (data) => {
                const recordList = data['record_list']

                if (recordList.length < data['total_rows']) {
                    const msg = this.t('Warning.dataAmountOver', {
                        total: data['total_rows'],
                        length: recordList.length,
                    })
                    utils.addToast(msg, 'warning')
                }

                this.table.SetData(recordList, this.props.currency)
            },
            (_err) => {
                this.table.SetData([])
            }
        )
    }

    render() {
        return <Table ownerName="PaymentFlowRecordTable" columns={this.columns} onRef={(ref) => (this.table = ref)} options={{export: this.options.export}} />
    }
}

const styles = (_theme) => {
    return {}
}

PaymentFlowRecordTable.propTypes = {
    classes: PropTypes.object.isRequired,
    onRef: PropTypes.func,
    dataService: PropTypes.object,
    currency: PropTypes.string,
}

export default hoc(styles)(PaymentFlowRecordTable)
